import {Method} from "./HttpMethods";

export interface GithubUser {
    login: string,
    id: number,
    avatar_url: string,
    gravatar_id: string,
    url: string,
    html_url: string,
    followers_url: string,
    following_url: string,
    gists_url: string,
    starred_url: string,
    subscriptions_url: string,
    organizations_url: string,
    repos_url: string,
    events_url: string,
    received_events_url: string,
    type: string,
    site_admin: false,
    name: string,
    company: string,
    blog: string,
    location: null,
    email: null,
    hireable: null,
    bio: null,
    public_repos: 6,
    public_gists: 0,
    followers: 0,
    following: 0,
    created_at: string,
    updated_at: string
}

const apiHost = 'https://api.github.com'
export class GithubApi {
  constructor(private token: string){
  }

  public get user() : JQueryPromise<GithubUser> {
    return this.request<GithubUser>(`${apiHost}/user`, Method.GET);
  }

  private get authHeader() : string {
    return `token ${this.token}`;
  }
  
  private request<T>(url: string, method:Method, data?: any) : JQueryPromise<T> {
    return $.ajax({
      url: url,
      type: Method[method],
      contentType: 'application/json',
      data: data ? JSON.stringify(data) : data,
      headers: {
            'Authorization': this.authHeader,
            'Accept': 'application/vnd.github.v3+json'
        }
    })
  }
}


// WEBPACK FOOTER //
// ./Client/Services/GithubApi.ts